export default {
    SMAPY_API_KEY: 'c0kFFTq9ZWrKIJxZvNS9zOAFMXGd_TK1f_r_gUUCOmM'
}